module.exports = __webpack_public_path__ + "img/9788993824414.9a06f0da.jpg";